const certModalOpen = (getUserInfo = {}, getCompanyInfo = {}) => {
  //본인인증 하지 않을 경우 인증 후 Modal

  if (Object.keys(getUserInfo).length === 0 || !getUserInfo || getUserInfo["code"] !== getCompanyInfo["code"]) {
    return true;
  }
  //사용자 정보가 존재하면서, 사용자정보companyCode(code), 회사 code가 같으면 이동
  else if (Object.keys(getUserInfo).length > 0 && getUserInfo["code"] === getCompanyInfo["code"]) {
    return false;
  }
};

export { certModalOpen };
